<!--
=============================================================================
setera-web
=============================================================================
Copyright (c) 2025 HG Digital/Setera
Todos os direitos reservados.

Este software é confidencial e de propriedade da HG Digital/Setera.
Seu uso está sujeito aos termos do contrato de licença.
-----
Criado em : 30-06-2025
Autor     : diegobrock
Projeto   : setera-web
Versão    : 1.0.0
=============================================================================
-->

<h2 mat-dialog-title>
  <mat-icon>video_camera_front</mat-icon>
  Streaming de Vídeo - {{ currentPosition.placa }}
</h2>

<div mat-dialog-content>
  <!-- Loading para sessão -->
  <mat-progress-bar *ngIf="sessionLoading" mode="indeterminate" color="accent"></mat-progress-bar>
  <!-- Loading para stream -->
  <mat-progress-bar *ngIf="isLoading && !sessionLoading" mode="indeterminate"></mat-progress-bar>

  <!-- Erro de sessão -->
  <div *ngIf="sessionError" class="alert alert-warning">
    <mat-icon>warning</mat-icon>
    {{ sessionError }}
  </div>
  <!-- Erro de stream -->
  <div *ngIf="errorMessage && !sessionError" class="alert alert-danger">
    <mat-icon>error</mat-icon>
    {{ errorMessage }}
  </div>

  <!-- Informações da Sessão -->
  <mat-card class="session-card" *ngIf="currentSession">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>info</mat-icon>
        Informações da sessão
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="session-details">
        <div class="session-row" *ngIf="currentPosition?.nome_empresa"><span class="label">Empresa:</span> <span class="value">{{ currentPosition.nome_empresa }}</span></div>
        <div class="session-row" *ngIf="currentPosition?.placa"><span class="label">Placa:</span> <span class="value">{{ currentPosition.placa }}</span></div>
        <div class="session-row">
          <span class="label">Câmera:</span> 
          <span class="value">{{ getLogicalChannelDescription(currentSession.logicalChannel || 1) }}</span>
        </div>
        <div class="session-row">
          <span class="label">Tempo restante:</span>
          <span class="value" [ngClass]="{'expired': timeRemainingSeconds <= 0, 'waiting': !playbackStarted}">
            {{ playbackStarted ? formatTimeRemaining(timeRemainingSeconds) : 'Aguardando reprodução...' }}
          </span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>


  <!-- Player de vídeo -->
  <div class="video-container">
    <video #videoPlayer class="video-player" controls autoplay muted playsinline [class.hidden]="!playerReady || isLoading"></video>
    <div *ngIf="!playerReady && !isLoading" class="no-video">
      <mat-icon class="no-video-icon">videocam_off</mat-icon>
      <p>Streaming via SRS Server</p>
      <p>Protocolo: FLV</p>
      <p *ngIf="currentStreamInfo">URL: {{ currentStreamInfo.url }}</p>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="actions-row">
  <!--<button mat-raised-button color="warn" *ngIf="currentSession" (click)="cancelSession()">
    Cancelar Sessão
  </button>-->
  <button mat-raised-button color="primary" (click)="close()">
    Fechar
  </button>
</div> 